<template>
  <div class="zone-selection-info">
    <div class="wrapper">
      <t-header class="header">
        <t-container>
          <img :src="require('@/assets/zone-overview/zone_selection_badge.png')" class="badge" />
          <h1 class="headline">{{ $t('zoneOverview.main.title') }}</h1>
        </t-container>
      </t-header>
      <t-container>
        <t-text class="info-layout">
          <div class="info-box" v-html="md($t('zoneSelectionInfo.box1.text'))"></div>
          <div class="info-box" v-html="md($t('zoneSelectionInfo.box2.text'))"></div>
          <div class="info-box" v-html="md($t('zoneSelectionInfo.box3.text'))"></div>
        </t-text>
      </t-container>
    </div>
  </div>
</template>

<script setup lang="ts">
// Info section on top of the zone selection page
import { marked } from 'marked'

function md(text: string) {
  return marked(text)
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../styles/vars';
.header {
  background-image: url('../assets/zone-overview/zone_selection_background.jpg'),
    linear-gradient(to bottom, #253475 25%, #4262bd 100%);
  background-repeat: no-repeat;
  background-position: bottom center, center center;
}
.t-container {
  display: flex;
  justify-items: center;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}
.headline {
  position: relative;
  display: inline-block;
  margin-right: 20.5em;
  left: 0;
  color: white;
  font-size: 2.375em;
  line-height: 1.1em;
  font-weight: 700;
  @media screen and (max-width: 830px) {
    margin-right: auto;
  }
  @media screen and (max-width: 660px) {
    transform: translateY(-1em);
  }
}
.badge {
  position: absolute;
  width: 34.625em;
  height: 12.875em;
  top: 0.25em;
  left: 50%;
  transform: translateX(-50%);
}
.wrapper {
  width: 100%;
  background: white;
  border-bottom: 1px solid @c0-c;
}
.info-layout {
  // max width should orientate on main width
  /*max-width: 800px;*/
  display: flex;
  justify-content: space-between;
  margin: auto;
  padding-top: 0.5em;
  width: 100%;
  @media screen and (max-width: 800px) {
    flex-wrap: wrap;
    padding: @biggerspacing 0;
  }
  &::v-deep {
    h2 {
      font-size: 1.25em;
      line-height: 1.25em;
      margin-bottom: 0;
    }
  }
}

.info-box {
  padding: @smallerspacing;
  text-align: center;
  flex: 1 1;
  @media screen and (max-width: 800px) {
    flex: 0 0 100%;
    padding: 0 @smallerspacing;
  }
}
</style>
